export const LadyRidgewayHospital = () => {
  return (
    <div style={{ padding: "10px" }}>
      <div style={{ textAlign: "center" }}>
        <h1 id="lady-ridgeway-hospital">Lady Ridgeway Hospital</h1>
      </div>
    </div>
  );
};
